export default __webpack_public_path__ + "static/media/lend_banner_bg.c500c414.png";